// Lightweight, provider-agnostic analytics helper.
//
// Fires a single event to whichever analytics tool is loaded on the page:
//   - Google Analytics 4 (window.gtag)
//   - Google Tag Manager (window.dataLayer)
//   - PostHog (window.posthog) — already loaded by public/index.html
//
// If none are available, the event is logged to the console in development so
// you can still verify behaviour locally.
//
// Usage:
//   import { trackEvent } from "@/lib/analytics";
//   trackEvent("book_visit_click", { location: "floating-menu" });

export const trackEvent = (eventName, params = {}) => {
  try {
    // Google Analytics 4
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
    }
    // Google Tag Manager
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: eventName, ...params });
    }
    // PostHog (already loaded via public/index.html)
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(eventName, params);
    }
    // Fallback in development
    if (
      typeof window !== "undefined" &&
      !window.gtag &&
      !Array.isArray(window.dataLayer) &&
      !window.posthog
    ) {
      // eslint-disable-next-line no-console
      console.debug("[analytics]", eventName, params);
    }
  } catch (_e) {
    // Analytics should never break the app.
  }
};
